import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const PickupReturn: React.FC = () => {
  const content = (
    <>
      <h2>Afhentning og returnering</h2>
      <p>
        Få det meste ud af din leje ved at følge disse bedste praksisser for afhentning og returnering af værktøj.
      </p>

      <h3>Før afhentning</h3>
      <p>
        Forbered dig ved at:
      </p>
      <ul>
        <li>Bekræfte tid og sted med ejeren</li>
        <li>Have din mobil klar til at tage billeder</li>
        <li>Medbringe eventuel aftalt betaling</li>
        <li>Sikre dig du har plads til transport</li>
      </ul>

      <h3>Ved afhentning - Tjekliste</h3>
      <p>
        Når du møder ejeren:
      </p>
      <ul>
        <li><strong>Mød til tiden:</strong> Respektér ejerens tid</li>
        <li><strong>Vær høflig:</strong> Hils og præsentér dig</li>
        <li><strong>Inspicér værktøjet:</strong> Tjek for eksisterende skader</li>
        <li><strong>Tag billeder:</strong> Dokumentér tilstanden</li>
        <li><strong>Test det:</strong> Bed om at se det virke hvis muligt</li>
        <li><strong>Få instruktioner:</strong> Lær hvordan man bruger det</li>
        <li><strong>Tjek tilbehør:</strong> Bekræft hvad der følger med</li>
        <li><strong>Håndter betaling:</strong> Som I har aftalt</li>
      </ul>

      <h3>Hvad skal du tjekke for?</h3>
      <p>
        Inspicér værktøjet for:
      </p>
      <ul>
        <li>Synlige skader eller revner</li>
        <li>Rust eller slitage</li>
        <li>At alle dele er til stede</li>
        <li>At det tænder og fungerer</li>
        <li>At sikkerhedsfunktioner virker</li>
      </ul>
      <p>
        Hvis noget ikke er som forventet, kommunikér det straks med ejeren.
      </p>

      <h3>Tag gode dokumentationsbilleder</h3>
      <p>
        Tag billeder af:
      </p>
      <ul>
        <li>Værktøjet fra alle sider</li>
        <li>Eventuelle eksisterende skader tæt på</li>
        <li>Serienummer hvis synligt</li>
        <li>Alt medfølgende tilbehør</li>
      </ul>
      <p>
        Dette beskytter både dig og ejeren hvis der senere opstår uenighed.
      </p>

      <h3>Transport af værktøjet</h3>
      <p>
        Sikre transport:
      </p>
      <ul>
        <li>Brug original emballage hvis muligt</li>
        <li>Fastgør værktøjet så det ikke rystes</li>
        <li>Beskyt skarpe kanter</li>
        <li>Sørg for det ikke kan falde eller blive beskadiget</li>
      </ul>

      <h3>Under lejeperioden</h3>
      <p>
        Pas godt på værktøjet:
      </p>
      <ul>
        <li>Opbevar det sikkert og tørt</li>
        <li>Brug det kun til dets formål</li>
        <li>Følg sikkerhedsinstruktioner</li>
        <li>Rengør det efter brug</li>
        <li>Kontakt ejeren ved problemer</li>
      </ul>

      <h3>Før returnering</h3>
      <p>
        Forbered værktøjet:
      </p>
      <ul>
        <li>Rengør det grundigt</li>
        <li>Fjern snavs, støv og rester</li>
        <li>Samle al medfølgende tilbehør</li>
        <li>Emballér det som ved afhentning</li>
        <li>Tjek kalender for returneringstid</li>
      </ul>

      <h3>Ved returnering - Tjekliste</h3>
      <p>
        Når du returnerer værktøjet:
      </p>
      <ul>
        <li><strong>Vær til tiden:</strong> Returner efter aftalen</li>
        <li><strong>Medbring alt:</strong> Værktøj og tilbehør</li>
        <li><strong>Lad ejeren inspicere:</strong> Giv tid til at tjekke tilstanden</li>
        <li><strong>Tag billeder:</strong> Dokumentér returnering</li>
        <li><strong>Bekræft i appen:</strong> Marker som returneret</li>
        <li><strong>Håndter evt. depositum:</strong> Få det tilbage</li>
        <li><strong>Tak ejeren:</strong> Vær venlig og professionel</li>
      </ul>

      <h3>For sent returnering</h3>
      <p>
        Hvis du ikke kan returnere til tiden:
      </p>
      <ul>
        <li>Kontakt ejeren så tidligt som muligt</li>
        <li>Forklar situationen</li>
        <li>Spørg om du kan forlænge lejen</li>
        <li>Vær forberedt på at betale for ekstra dage</li>
      </ul>

      <h3>Hvis værktøjet er beskadiget</h3>
      <p>
        Ved skader under din leje:
      </p>
      <ul>
        <li>Informér ejeren omgående</li>
        <li>Dokumentér skaden med billeder</li>
        <li>Vær ærlig om hvad der skete</li>
        <li>Diskutér kompensation</li>
        <li>Kontakt DoMore support hvis nødvendigt</li>
      </ul>

      <h3>Efter returnering</h3>
      <p>
        Husk at:
      </p>
      <ul>
        <li>Efterlade en anmeldelse</li>
        <li>Bed\u00f8mme din oplevelse</li>
        <li>Hjælpe andre brugere med din feedback</li>
      </ul>
    </>
  );

  return (
    <HelpArticle
      title="Afhentning og returnering"
      category="Værktøjsleje"
      content={content}
      relatedArticles={[
        { title: 'Bookingprocessen forklaret', link: '/help/booking-process' },
        { title: 'Hvad sker der hvis et værktøj går i stykker?', link: '/help/tool-damage' },
      ]}
    />
  );
};

export default PickupReturn;
